import axios, { ResponseType } from './axios';
import { Account, AccountBalance, ExportBalancesBody, ExportCheck, Limit } from '~/types';

export type DataType = {
  cursors?: { next?: string };
  balances: AccountBalance[];
};

export const getAccounts = (params?: {
  page?: number;
  perPage?: number;
  [key: string]: any;
}): ResponseType<Account[]> => {
  return axios.get('/accounts', { params });
};

export const changeAccountAlias = async ({
  id,
  alias,
}: {
  id: string;
  alias: string;
}): ResponseType<void> => {
  return axios.put(`/accounts/${id}/alias`, { alias });
};

export const getLimits = (id: string) => (): ResponseType<Limit[]> => {
  return axios.get(`/accounts/${id}/limits`);
};

export const getAccountsBalances = ({
  limit,
  next,
  filters,
}: {
  limit: number;
  next?: string;
  filters?: {
    accountId?: string;
    bankingDayFrom?: string;
    bankingDayTo?: string;
  };
}) => {
  return axios
    .get<DataType>('/report/balances', { params: { limit, ...filters, next } })
    .then((res) => res.data);
};

export const getBalancesExportCheck = () => {
  return axios.get<ExportCheck>(`/report/balances/export/check`).then((res) => res.data);
};

export const getBalancesExport = (body: ExportBalancesBody) => {
  return axios.post('/report/balances/export', body).then((res) => res.data);
};

export const getBalancesExportStatus = (exportId: string) => {
  return axios.get(`/report/balances/export/${exportId}`).then((res) => res.data);
};

export const getBalancesExportResult = (exportId: string) => {
  return axios
    .get(`/report/balances/export/${exportId}/result`, {
      responseType: 'blob',
    })
    .then((res) => res.data);
};
